import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AppService } from "../app.service";
import { LocalStorageService } from "../localStorage.service";

@Injectable({
  providedIn: "root",
})
export class GoogleMapsService {
  constructor(private appService: AppService, private localStorageService: LocalStorageService) { }
  private googleMapsLoaded: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  getGoogleMapsLoaded(): Observable<any> {
    return this.googleMapsLoaded.asObservable();
  }
  existingScript() {
    return document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]'
    ) ? true : false;
  }

  loadGoogleMaps(googleApiUrl: string) {
    const existingScript = this.existingScript();
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = googleApiUrl;
      script.async = true;
      script.defer = true;
      script.onload = (res) => {
        this.googleMapsLoaded.next(true);
      };
      script.onerror = (error) => {
        if (error instanceof ErrorEvent) {
          console.error("Failed to load Google Maps script:", error.message);
        } else {
          console.error(
            "Failed to load Google Maps script, unknown error:",
            error
          );
        }
        this.googleMapsLoaded.next(false);
      };
      document.body.appendChild(script);
    } else {
      this.googleMapsLoaded.next(true);
    }
  }
  initMapUrl() {
    const existingScript = this.existingScript();
    const settings = this.localStorageService.getSettings();
    if (!existingScript) {
      const key = settings && settings.google_maps_key ? settings.google_maps_key : "AIzaSyDW60oc6nhqpEQnH-Vimum6u5Y7_0PtPvY";
      const googleApiUrl = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=geometry,marker,places,drawing&loading=async&callback=Function.prototype`;
      this.loadGoogleMaps(googleApiUrl);
    }else{
      this.googleMapsLoaded.next(true);

    }
  }
}
